import { useEffect, useState } from "react";
import { DefaultDataGridReport } from "../components/DefaultDataGrid";
import { DefaultPaperReport } from "../components/DefaultPaper";
import { calculateTimeRange } from "../../../utils/timeUtils";
import {
  IReportMetricsItem,
  IReportMetricsRow,
  IReportMetricsTotal,
} from "../../../@types/reports-metrics.type";
import { getPositionsMetrics } from "../../../services/api/positions/PositionsService";
import { SelectedType } from "./../index";

const createInitialMetricsTotal = (): IReportMetricsTotal => {
  return {
    totalScheduled: "-",
    totalBillable: "-",
    totalNonBillable: "-",
    totalScheduledPercentage: 0,
    totalBillablePercentage: 0,
    totalNonBillablePercentage: 0,
  };
};

export const ReportPositions: React.FC<{
  filterState: any;
  selectedType: SelectedType | null;
  setRowSelected: React.Dispatch<
    React.SetStateAction<IReportMetricsRow | null>
  >;
  setSelectedType: React.Dispatch<React.SetStateAction<SelectedType | null>>;
  setValueTab: React.Dispatch<React.SetStateAction<number>>;
  valueTab: number;
}> = ({
  filterState,
  selectedType,
  setRowSelected,
  setSelectedType,
  setValueTab,
  valueTab,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [rolesMetrics, setRolesMetrics] = useState<IReportMetricsItem[]>([]);
  const [rolesMetricsRows, setRolesMetricsRows] = useState<IReportMetricsRow[]>(
    []
  );
  const [rolesMetricsTotal, setRolesMetricsTotal] =
    useState<IReportMetricsTotal>(createInitialMetricsTotal);
  const [totalRows, setTotalRows] = useState(0);

  async function fetchAllCustomersMetrics() {
    try {
      setLoading(true);
      const { startDate, endDate } = calculateTimeRange(
        filterState.currentPeriod,
        filterState.period
      );
      const startTime = startDate.startOf("day").toISOString();
      const endTime = endDate.startOf("day").toISOString();
      const response = await getPositionsMetrics({
        startTime: startTime,
        endTime: endTime,
        timeType: filterState.timeMode,
      });
      setTotalRows(response.result.metric.length);
      setRolesMetrics(response.result.metric);
      setRolesMetricsTotal({
        totalScheduled:
          filterState.timeMode === 1
            ? `${response.result.totalScheduled.toLocaleString("pt-BR") || 0}h`
            : `${response.result.totalScheduled.toLocaleString("pt-BR") || 0}d`,
        totalBillable:
          filterState.timeMode === 1
            ? `${response.result.totalBillable.toLocaleString("pt-BR") || 0}h`
            : `${response.result.totalBillable.toLocaleString("pt-BR") || 0}d`,
        totalNonBillable:
          filterState.timeMode === 1
            ? `${response.result.totalNonBillable.toLocaleString("pt-BR") || 0}h`
            : `${response.result.totalNonBillable.toLocaleString("pt-BR") || 0}d`,
        totalScheduledPercentage:
          response.result.totalScheduledPercentage != null
            ? Number(response.result.totalScheduledPercentage.toFixed(2))
            : 0,
        totalBillablePercentage:
          response.result.totalBillablePercentage != null
            ? Number(response.result.totalBillablePercentage.toFixed(2))
            : 0,
        totalNonBillablePercentage:
          response.result.totalNonBillablePercentage != null
            ? Number(response.result.totalNonBillablePercentage.toFixed(2))
            : 0,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAllCustomersMetrics();
    setSelectedType("position");
  }, [filterState]);

  const transformMetricsToRows = (
    metrics: IReportMetricsItem[]
  ): IReportMetricsRow[] => {
    return metrics.map((item) => ({
      id: item.id,
      name: item.name,
      totalScheduled:
        filterState.timeMode === 1
          ? `${item.scheduled}h`
          : `${item.scheduled}d`,
      percentScheduled: item.scheduledPercentage,
      billed:
        filterState.timeMode === 1 ? `${item.billable}h` : `${item.billable}d`,
      notBilled:
        filterState.timeMode === 1
          ? `${item.nonBillable}h`
          : `${item.nonBillable}d`,
      contractedHours:
        filterState.timeMode === 1
          ? `${item.contracted ?? 0}h`
          : `${item.contracted ?? 0}d`,
    }));
  };

  useEffect(() => {
    const transformedRows = transformMetricsToRows(rolesMetrics);
    setRolesMetricsRows(transformedRows);
  }, [rolesMetrics]);

  return (
    <>
      <DefaultPaperReport
        scheduledData={String(rolesMetricsTotal?.totalScheduled)}
        billedData={String(rolesMetricsTotal?.totalBillable)}
        billedPercentData={rolesMetricsTotal?.totalBillablePercentage}
        notBilledData={String(rolesMetricsTotal?.totalNonBillable)}
        notBilledPercentData={rolesMetricsTotal?.totalNonBillablePercentage}
        filterState={filterState}
      />
      <DefaultDataGridReport
        columnName="Função"
        rows={rolesMetricsRows}
        rowCount={totalRows}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        setRowSelected={setRowSelected}
        setValueTab={setValueTab}
        valueTab={valueTab}
        loading={loading}
        filterState={filterState}
      />
    </>
  );
};
